<template>
  <!-- Begin About Me Section -->
  <div class="section-light about-me" id="about-me">
    <div class="container">
      <div class="column is-12 about-me">
        <h1 class="title has-text-centered section-title">{{ $t('message.aboutMe.head') }}</h1>
      </div>
      <br />
      <div class="columns is-multiline">
        <div class="column is-6 has-vertically-aligned-content" data-aos="fade-right">
          <p class="is-larger">
            <strong v-html="$t('message.aboutMe.strongText')" />
          </p>
          <br />
          <p v-html="$t('message.aboutMe.description')" />
          <br />
          <p><a href="#contact">
            <div class="button" style="font-size: x-large">{{ $t('message.contact.link') }}</div>
            </a></p>
        </div>
        <div class="column is-6 right-image" data-aos="fade-left">
          <img
            class="is-rounded"
            src="img/keyboard-mouse.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutMe'
}
</script>
